import { render, staticRenderFns } from "./NewsContest.vue?vue&type=template&id=203969d2&scoped=true&"
import script from "./NewsContest.vue?vue&type=script&lang=ts&"
export * from "./NewsContest.vue?vue&type=script&lang=ts&"
import style0 from "./NewsContest.vue?vue&type=style&index=0&id=203969d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203969d2",
  null
  
)

export default component.exports